module.exports = __webpack_public_path__ + "media/images/athletes/146-bb84bee41440e2dcf50c809d079ab8bf.png";